import { windowWidth } from '../../constants';

export default () => {
  const navigationItems = $('.homepage-academy-v2-courses__navigations-item');

  navigationItems.on('click', function () {
    navigationItems.removeClass('selected');
    $(this).addClass('selected');
    $('.homepage-academy-v2-courses__list').hide();

    const targetId = $(this).data('target-id');
    if (windowWidth < 1200) {
      $(`#${targetId}`).show();
    } else {
      $(`#${targetId}`).css('display', 'flex');
    }
  });
};
